import React, { useEffect, useState } from "react";
import axios from "axios";
import cancel from '../assets/cancel.png'
import serverURL from '../config'
import { toast } from 'react-toastify';
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const EventModal = ({ title, event, closeEventModal, fetchEvents }) => {
    const [formData, setFormData] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setFormData({
            name: event?.name || '',
            institution: event?.institution || '',
            event_date: event?.event_date || '',
            candidate_count: event?.candidate_count || '',
            passkey: event?.passkey || '',
            duration: event?.duration || '',
            difficulty_level: event?.difficulty_level || '',
            pass_percentage: event?.pass_percentage || '',
        });
    }, [event]);
    



    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleClose = () => {
        setFormData({});
        closeEventModal();
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        if (title !== "Delete Event") {
            if (!formData.name || !formData.event_date || !formData.passkey || !formData.institution) {
                toast.error('Please fill in all required fields.');
                setLoading(false);
                return;
            }
        }

        const token = localStorage.getItem('token');

        try {
            const headers = {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            };

            let response;
            if (title === "Add Event") {
                response = await axios.post(`${serverURL}/events`, formData, { headers });
                toast.success('Event created successfully!');
            } else if (title === "Edit Event") {
                response = await axios.put(`${serverURL}/events/${event.id}`, formData, { headers });
                toast.success('Event edited successfully!');
            } else if (title === "Delete Event") {
                response = await axios.delete(`${serverURL}/events/${event.id}`, { headers });
                toast.success('Event deleted successfully!');
            }
            if(fetchEvents){
                fetchEvents();
            }
            handleClose();
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || 'An unexpected error occurred.';
            toast.error(errorMessage);
            console.error('Error details:', error.response || error.message);
        }

        setLoading(false);
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="bg-white p-6 rounded shadow-lg relative w-1/3 overflow-y-auto" style={{ maxHeight: "80vh" }}>
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-xl font-bold text-red-500">{title}</h3>
                    <button
                        onClick={handleClose}
                        className="text-white rounded"
                    >
                        <img src={cancel} width={"25px"} alt="Close" />
                    </button>
                </div>
                {title === 'Delete Event' ? (
                    <div className="flex flex-col items-center justify-center py-3 gap-4">
                        <h3 className="text-xl text-black">
                            Are you sure to delete this event?
                        </h3>
                        <button onClick={handleSubmit} className="bg-red-500 px-5 py-2 text-white rounded">
                            Yes
                        </button>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit}>
                        <div className="mb-4">
                            <label className="block text-gray-700 text-sm font-bold mb-2">
                                Event Name
                            </label>
                            <input
                                type="text"
                                name="name"
                                placeholder="Enter event name"
                                value={formData.name || ''}
                                onChange={handleChange}
                                className={`w-full p-2 border rounded ${!formData.name && 'border-red-500'}`}
                            />
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-700 text-sm font-bold mb-2">
                                Institution Name
                            </label>
                            <input
                                type="text"
                                name="institution"
                                placeholder="Enter institution name"
                                value={formData.institution || ''}
                                onChange={handleChange}
                                className={`w-full p-2 border rounded ${!formData.institution && 'border-red-500'}`}
                            />
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-700 text-sm font-bold mb-2">
                                Event Date
                            </label>
                            <input
                                type="datetime-local"
                                name="event_date"
                                value={formData.event_date || ''}
                                onChange={handleChange}
                                className={`w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring focus:ring-blue-500 ${!formData.event_date && 'border-red-500'}`}
                            />
                        </div>

                        <div className="mb-4">
                            <label className="block text-gray-700 text-sm font-bold mb-2">
                                Candidate Count
                            </label>
                            <input
                                type="number"
                                name="candidate_count"
                                placeholder="Enter candidate count"
                                value={formData.candidate_count || ''}
                                onChange={handleChange}
                                className={`w-full p-2 border rounded ${!formData.candidate_count && 'border-red-500'}`}
                            />
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-700 text-sm font-bold mb-2">
                                Passkey
                            </label>
                            <input
                                type="text"
                                name="passkey"
                                placeholder="Enter event passkey"
                                value={formData.passkey || ''}
                                onChange={handleChange}
                                className={`w-full p-2 border rounded ${!formData.passkey && 'border-red-500'}`}
                            />
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-700 text-sm font-bold mb-2">
                                Duration (minutes)
                            </label>
                            <input
                                type="number"
                                name="duration"
                                placeholder="Enter duration"
                                value={formData.duration || ''}
                                onChange={handleChange}
                                className={`w-full p-2 border rounded ${!formData.duration && 'border-red-500'}`}
                            />
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-700 text-sm font-bold mb-2">
                                Difficulty Level
                            </label>
                            <select
                                name="difficulty_level"
                                value={formData.difficulty_level || ''}
                                onChange={handleChange}
                                className={`w-full p-2 border rounded ${!formData.difficulty_level && 'border-red-500'}`}
                            >
                                <option value="" disabled>Select Difficulty Level</option>
                                <option value="easy">Easy</option>
                                <option value="medium">Medium</option>
                                <option value="hard">Hard</option>
                            </select>
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-700 text-sm font-bold mb-2">
                                Pass Percentage
                            </label>
                            <input
                                type="number"
                                name="pass_percentage"
                                placeholder="Enter pass percentage"
                                min={23}
                                value={formData.pass_percentage || ''}
                                onChange={handleChange}
                                className={`w-full p-2 border rounded ${!formData.pass_percentage && 'border-red-500'}`}
                            />
                        </div>
                        <div className="flex justify-end">
                            <button
                                type="submit"
                                className="bg-red-500 text-white px-4 py-2 rounded"
                            >
                                Save
                            </button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    )
}

export default EventModal;